import actions from "./actions";

const fetchConfig = () => ( dispatch ) => {
  window.api.getAppConfig().then(
    response => dispatch(actions.setConfig(response)),
    error => dispatch(actions.setConfig(error))
  )
}
const setOriginFieldInfos = actions.setOriginFieldInfos;
const setPerimeterFieldInfos = actions.setPerimeterFieldInfos;

const setSortField = (sortField) => ( dispatch ) => {
  window.api.setSortField(sortField);
  dispatch(actions.setSortField(sortField));
};

const setSortDesc = (sortDesc) => ( dispatch ) => {
  window.api.setSortDesc(sortDesc);
  dispatch(actions.setSortDesc(sortDesc));
};

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  fetchConfig,
  setOriginFieldInfos,
  setPerimeterFieldInfos,
  setSortField,
  setSortDesc
};
